import React from "react";
import {
  Image,
  withSitecoreContext,
  Link,
} from "@sitecore-jss/sitecore-jss-react";
import { LightWeightHeaderProps } from "./types/LightWeightHeader.types";
import "./index.scss";

const LightWeightHeader = (props: LightWeightHeaderProps) => {
  const headerlinks = props.fields?.headerlinks;

  return (
    <>
      {props.fields && (
        <div className="LightWeightHeader__Wrapper" id={props?.rendering?.uid}>
          <div className={"LightWeightHeader__root"}>
            {headerlinks?.map((item, index: number) => (
              <div className={"LightWeightHeader__Image"} key={index}>
                {item.fields?.imageurl?.value?.href ? (
                  <Link
                    field={item?.fields?.imageurl}
                    className={`TimerBanner__TextWrapper--Link`}
                  >
                    <Image
                      field={item?.fields?.image}
                      className={`LightWeightHeader__Image--Logo`}
                    />
                  </Link>
                ) : (
                  <Image
                    field={item?.fields?.image}
                    className={`LightWeightHeader__Image--Logo`}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
export default withSitecoreContext()(LightWeightHeader);
